import { type Page } from './constants';
import createErrors from '../createErrors';

export type Component = 'ForgotPassword';

/**
 * Errors related to the Reset Password page
 */
export const Errors = createErrors<Page, Component>('Root')({
    ForgotPassword: {
        SubmitFailed: {
            severity: 'HIGH',
            message: 'Failed to reset password',
        },
    },
});
